<template>
  <v-footer
    color="transparent"
    padless
    class="agent-footer"
    style="background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);"
  >
    <v-container>
      <v-row class="footer-content">
        <!-- Company Info -->
        <v-col cols="12" md="4" class="footer-section">
          <div class="footer-logo" style="cursor: pointer;" @click="$router.push('/agents')">
            <img
              src="@/assets/img/logo.png"
              alt="AutoSyncX™"
              height="85"
              class="footer-logo-img"
            />
            <div class="footer-brand-text">
              <span class="footer-brand-name">AutoSyncX™</span>
              <span class="agent-badge-footer">Agent Portal</span>
            </div>
          </div>
          <p class="footer-description">
            Connecting referring agents with thousands of dealerships nationwide.
            Start earning commissions and build your referral business with AutoSyncX™.
          </p>
          <div class="footer-social">
            <v-btn
              icon
              small
              class="social-btn"
              href="#"
              target="_blank"
            >
              <v-icon class="material-icons-round">facebook</v-icon>
            </v-btn>
            <v-btn
              icon
              small
              class="social-btn"
              href="#"
              target="_blank"
            >
              <v-icon class="material-icons-round">twitter</v-icon>
            </v-btn>
            <v-btn
              icon
              small
              class="social-btn"
              href="#"
              target="_blank"
            >
              <v-icon class="material-icons-round">linkedin</v-icon>
            </v-btn>
          </div>
        </v-col>

        <!-- Quick Links -->
        <v-col cols="12" md="2" class="footer-section">
          <h4 class="footer-section-title">Quick Links</h4>
          <div class="footer-links">
            <router-link to="/agents" class="footer-link">Home</router-link>
            <router-link to="/signup" class="footer-link">Get Started</router-link>
            <router-link to="/login" class="footer-link">Login</router-link>
            <router-link to="/pricing" class="footer-link">Pricing</router-link>
          </div>
        </v-col>

        <!-- Agent Resources -->
        <v-col cols="12" md="2" class="footer-section">
          <h4 class="footer-section-title">Resources</h4>
          <div class="footer-links">
            <a href="#" class="footer-link">Agent Training</a>
            <a href="#" class="footer-link">Marketing Tools</a>
            <a href="#" class="footer-link">Commission Guide</a>
            <a href="#" class="footer-link">Success Stories</a>
          </div>
        </v-col>

        <!-- Support -->
        <v-col cols="12" md="2" class="footer-section">
          <h4 class="footer-section-title">Support</h4>
          <div class="footer-links">
            <a href="#" class="footer-link">Help Center</a>
            <a href="#" class="footer-link">Contact Us</a>
            <a href="#" class="footer-link">Live Chat</a>
            <a href="#" class="footer-link">Phone Support</a>
          </div>
        </v-col>

        <!-- Legal -->
        <v-col cols="12" md="2" class="footer-section">
          <h4 class="footer-section-title">Legal</h4>
          <div class="footer-links">
            <router-link to="/terms-and-conditions" class="footer-link">Terms of Service</router-link>
            <router-link to="/privacy-policy" class="footer-link">Privacy Policy</router-link>
            <a href="#" class="footer-link">Agent Agreement</a>
            <a href="#" class="footer-link">Compliance</a>
          </div>
        </v-col>
      </v-row>

      <!-- Footer Bottom -->
      <v-divider class="footer-divider"></v-divider>
      <v-row class="footer-bottom">
        <v-col cols="12" md="6">
          <p class="footer-copyright">
            © {{ currentYear }} AutoSyncX™. All rights reserved.
          </p>
        </v-col>
        <v-col cols="12" md="6" class="text-md-right">
          <div class="footer-contact-info">
            <span class="contact-item">
              <v-icon small class="material-icons-round">phone</v-icon>
              +1 602-610-1072
            </span>
            <span class="contact-item">
              <v-icon small class="material-icons-round">email</v-icon>
              agents@autosyncx.com
            </span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'FooterAgent',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style scoped>
.agent-footer {
  color: white;
  padding: 60px 0 20px;
}

.footer-content {
  margin-bottom: 40px;
}

.footer-section {
  margin-bottom: 30px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  transition: transform 0.3s ease;
}

.footer-logo:hover {
  transform: scale(1.02);
}

.footer-logo-img {
  filter: brightness(0) invert(1);
}

.footer-brand-text {
  display: flex;
  flex-direction: column;
}

.footer-brand-name {
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  line-height: 1;
}

.agent-badge-footer {
  font-size: 0.75rem;
  font-weight: 600;
  color: #007bff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
  margin-top: 2px;
}

.footer-description {
  color: #cbd5e0;
  line-height: 1.6;
  margin-bottom: 20px;
  font-size: 0.95rem;
}

.footer-social {
  display: flex;
  gap: 8px;
}

.social-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #cbd5e0 !important;
  transition: all 0.3s ease !important;
}

.social-btn:hover {
  background: #007bff !important;
  color: white !important;
  transform: translateY(-2px) !important;
}

.footer-section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
  margin-bottom: 16px;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-link {
  color: #cbd5e0;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  padding: 4px 0;
}

.footer-link:hover {
  color: #007bff;
  text-decoration: none;
  padding-left: 8px;
}

.footer-divider {
  background: rgba(255, 255, 255, 0.1);
  margin: 20px 0;
}

.footer-bottom {
  align-items: center;
}

.footer-copyright {
  color: #a0aec0;
  font-size: 0.9rem;
  margin: 0;
}

.footer-contact-info {
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #cbd5e0;
  font-size: 0.9rem;
}

.contact-item .v-icon {
  color: #007bff;
}

/* Responsive Design */
@media (max-width: 960px) {
  .footer-brand-text {
    display: none;
  }
  
  .footer-contact-info {
    justify-content: flex-start;
    margin-top: 16px;
  }
  
  .footer-contact-info .contact-item {
    flex-direction: column;
    text-align: center;
    gap: 4px;
  }
}

@media (max-width: 600px) {
  .agent-footer {
    padding: 40px 0 20px;
  }
  
  .footer-contact-info {
    flex-direction: column;
    gap: 12px;
  }
  
  .footer-social {
    justify-content: center;
  }
  
  .footer-section {
    text-align: center;
    margin-bottom: 40px;
  }
  
  .footer-links {
    align-items: center;
  }
}
</style>
